import { Page } from "@/models/page-models/Page";

export const SparePartsPurchaseOrderEdit: Page = {
  "path": "add-spare-parts-purchase-order/:poId",
  "name": "Spare Parts PO",
  "props": {
    "data": {
      "title": "Spare Parts PO",
      "printable": "TRUE",
      "url": "add-spare-parts-purchase-order/:poId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "label": "PO#",
                  "showIf": "{{fetchedData.rmType}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,poCode,{{formData}},{{fetchedData}})",
                  "printable": false
                },
                {
                  "type": "label",
                  "label": "Created Date",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.createdAt}})",
                  "printable": false
                },
                {
                  "type": "label",
                  "label": "Amendment Date",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.updatedAt}})",
                  "printable": false
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.supplier._id",
                  "label": "Select Supplier",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyDefaultPageNo",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultPageNo",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.goodSearch",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyDefaultPageNo"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "getRmsBySupplierid",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/goods/supplier/{{formData.supplier._id}}/raw-material",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.goods",
                        "arg3Key": "postData",
                        "arg3Value": "fetchedData.goodSearch"
                      },
                      "name": "getRmsBySupplierid"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "copyRMs",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.goods.data.docs",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.filteredGoods"
                      },
                      "name": "copyRMs"
                    }
                  ],
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "copySupplierInternationalStatus"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.supplierList.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "printable": false
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "genericGroup",
          "label": "Shipping Info",
          "groupItems": [
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.currencyCode",
                  "label": "Currency Code",
                  "disabled": "FALSE",
                  "items": "[\"EUR\",\"USD\",\"SAR\",\"AED\"]",
                  "dropdownType": "static",
                  "printable": false
                },
                {
                  "type": "dropdown",
                  "variable": "formData.deliveryTerms",
                  "label": "Trade Terms",
                  "disabled": "FALSE",
                  "items": "fetchedData.tradeTermsDetails.data.0.data",
                  "itemText": "en",
                  "itemValue": "type",
                  "formula": "{{__item.en}} ({{__item.type}})"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.paymentTerms",
                  "label": "Payment Terms",
                  "disabled": "FALSE",
                  "items": "[\"CAD (Cash Against Documents)\",\"DFT30 (Draft 30 days from B/L Date)\",\"DFT60 (Draft 60 days from B/L Date)\",\"DFT90 (Draft 90 days from B/L Date)\",\"DFT120 (Draft 120 days from B/L Date)\",\"LC SGHT (ICLC Payable at Sight)\",\"LC30 (ICLC 30 days from B/L Date)\",\"LC45 (ICLC 45 days from B/L Date)\",\"LC60 (ICLC 60 days from B/L Date)\",\"LC90 (ICLC 90 days from B/L Date)\",\"LC120 (ICLC 120 days from B/L Date)\",\"TLX ADV (Advance Telex Transfer)\",\"TLX (Telex Transfer Upon Receipt)\",\"CHQ30 (Cheque 30 days on Goods Receipt)\",\"CHQ45 (Cheque 45 days on Goods Receipt)\",\"CHQ60 (Cheque 60 days on Goods Receipt)\",\"Cash\",\"FOC\",\"CHQ 75 Days from Date of Shipping\",\"CHQ 90 Days from Date of Shipping\",\"On Account\",\"TLX Transfer 120 Days from BL/TWB DATE\",\"TLX Transfer 90 Days from BL/TWB DATE\",\"TLX Transfer 60 Days from BL/TWB DATE\",\"TLX Transfer 30 Days from B/L DATE\",\"Cash in Advance Prior to Shipment By ...\",\"Advance 30% and CAD 70%\",\"Avalised Draft 90 days from BL/TWB Date\",\"Avalised Draft 60 days from B/L Date\",\"CAD 30 days with 2% discount on Invoice\",\"CAD 60 days from B/L Date\",\"CAD 75 days from B/L Date\",\"CAD 90 days from B/L Date\",\"CAD 120 days from B/L Date\",\"CAD 60 days from Invoice Date\",\"CAD 90 days from Invoice Date\",\"CAD 120 days from Invoice Date\",\"Telex Transfer - 50% Advance & 50% Before ...\",\"CAD 60 days\",\"CAD 90 days\"]",
                  "dropdownType": "static",
                  "printable": false
                },
                {
                  "type": "dropdown",
                  "variable": "formData.packingMode",
                  "label": "Packing Mode",
                  "disabled": "FALSE",
                  "items": "[\"Wrapped Rolls for Sea Worthy Shipment\",\"In brand new Steel Drums on Pallet ...\",\"In Rolls, Wrapped and Protected\",\"In Carton Box on Pallets Wrapped\",\"In Rolls, Wrapped and Protected with ...\",\"Wrapped Board For Seaworthy Shipment\",\"Usual Packing\",\"Carton Box\",\"In Rolls, Protected with Strong\",\"None\"]",
                  "dropdownType": "static",
                  "printable": false
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.shippingMarks",
                  "label": "Shipping Marks",
                  "disabled": "FALSE",
                  "items": "[\"Made In Germany\",\"Made In Brazil\",\"Made In Canada\",\"Made In India\",\"Made In Denmark\",\"Made In Belgium\",\"Made In U.S.A\",\"Made In China\",\"Made In Indonesia\",\"Made In Korea\",\"Made In K.S.A\",\"Made In Qatar\",\"Made in Sweden\",\"Made in France\",\"Made in Turkey\",\"Made in Spain\",\"Made in UAE\"]",
                  "dropdownType": "static",
                  "printable": false
                },
                {
                  "type": "dropdown",
                  "variable": "formData.shippingMode",
                  "label": "Shipping Mode",
                  "disabled": "FALSE",
                  "items": "[\"Ocean Vessel 20FT Container\",\"Ocean Vessel 40FT Container\",\"Ocean Vessel Break Bulk(Pallets)/ Tons ( LCL Shipment)\",\"Groupage Container Ocean Vessel\",\"Air Freight\",\"Air Post Parcel\",\"Van\",\"DHL Courier Service\",\"Purchaser\",\"Sea Freight\",\"Supplier\",\"Truck\",\"Road Tanker\",\"Ocean Vessel 20FT ISO Tanker\",\"None\"]",
                  "dropdownType": "static",
                  "printable": false
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.shippingDate",
                  "label": "Shipping Date",
                  "disabled": "FALSE",
                  "printable": false,
                  "showWeekNumber": true
                },
                {
                  "type": "dropdown",
                  "variable": "formData.homePort",
                  "label": "Destination Port",
                  "disabled": "FALSE",
                  "items": "[\"Dammam\",\"Jeddah\"]",
                  "dropdownType": "static",
                  "printable": false
                }
              ]
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.notes",
                  "label": "Additional Notes",
                  "disabled": "FALSE",
                  "printable": false
                }
              ]
            }
          ],
          "printable": false
        },
        {
          "type": "arrayGroup",
          "variable": "formData.requiredDocuments",
          "label": "Documents Required",
          "disabled": "FALSE",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "name"
                },
                {
                  "type": "input",
                  "variable": "original",
                  "label": "Original",
                  "disabled": "FALSE",
                  "fixedWidth": true
                },
                {
                  "type": "input",
                  "variable": "copy",
                  "label": "Copy",
                  "disabled": "FALSE",
                  "fixedWidth": true
                }
              ]
            }
          ],
          "printable": false,
          "initialValue": [
            {
              "name": "Invoice"
            },
            {
              "name": "Certificate of Origin"
            },
            {
              "name": "B/L/AWB"
            },
            {
              "name": "Packing List"
            },
            {
              "name": "Insurance Certificate"
            },
            {
              "name": "Certificate of Analysis"
            }
          ],
          "disableAddDelete": true
        },
        {
          "type": "arrayGroup",
          "variable": "formData.additionalDocuments",
          "disabled": "FALSE",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "name",
                  "label": "Name",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "original",
                  "label": "Original",
                  "disabled": "FALSE",
                  "fixedWidth": true
                },
                {
                  "type": "input",
                  "variable": "copy",
                  "label": "Copy",
                  "disabled": "FALSE",
                  "fixedWidth": true
                }
              ]
            }
          ],
          "printable": false,
          "initialArrayLength": 0
        },
        {
          "type": "arrayGroup",
          "variable": "formData.purchasedRMs",
          "label": "Spare Parts",
          "disabled": "FALSE",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "sparePart._id",
                  "label": "Spare Part",
                  "disabled": "FALSE",
                  "items": "fetchedData.allSpareParts.data",
                  "itemText": "description",
                  "itemValue": "_id"
                },
                {
                  "type": "input",
                  "variable": "unitQuantity",
                  "label": "Quantity",
                  "unit": "{{formData.purchasedRMs.{{__index}}.sparePart.unit}}",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "tolerance",
                  "label": "Tolerance",
                  "unit": "%",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "unitPrice",
                  "label": "Unit Price",
                  "unit": "{{formData.currencyCode}}",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "exemption",
                  "label": "Customs Spare Part Name",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "printable": false,
          "style": "border"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Print",
                  "disabled": "FALSE",
                  "color": "secondary",
                  "buttonType": "print"
                },
                {
                  "type": "button",
                  "label": "Update PO",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "updatePO"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary",
                  "printable": false
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Total Quantity",
                  "labelType": "formula",
                  "formula": "fn(ARRAY_SUM,{{__item.unitQuantity}},{{formData.purchasedRMs}})",
                  "filterType": "unit",
                  "filterParam": "{{formData.purchasedRMs.0.sparePart.unit}}",
                  "printable": false
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Total Amount",
                  "showIf": "{{fetchedData.selectedSupplier.data.isInternational}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,currency,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.unitQuantity}},{{__arrayItem.unitPrice}}),{{formData.purchasedRMs}},_id),{{formData.currencyCode}})",
                  "printable": false
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Total Amount",
                  "showIf": "{{{{fetchedData.selectedSupplier.data.isInternational}} === false}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,currency,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,fn(SUM,fn(MULTIPLY,{{fetchedData.companyDetails.data.0.data.vatPercentage}},0.01),1),{{__arrayItem.unitQuantity}},{{__arrayItem.unitPrice}}),{{formData.purchasedRMs}},_id),{{formData.currencyCode}})",
                  "printable": false
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "genericGroup",
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "label": "PO#",
                  "showIf": "{{fetchedData.rmType}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,poCode,{{formData}},{{fetchedData}})",
                  "printable": true
                },
                {
                  "type": "label",
                  "label": "Created Date",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.createdAt}})",
                  "printable": true
                },
                {
                  "type": "label",
                  "label": "Amendment Date",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.updatedAt}})",
                  "printable": true
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Supplier Shipping Info",
                  "printable": true
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.supplier.name",
                  "label": "Supplier",
                  "printable": true
                },
                {
                  "type": "label",
                  "variable": "formData.deliveryTerms",
                  "label": "Delivery Terms",
                  "printable": true
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.paymentTerms",
                  "label": "Payment Terms",
                  "printable": true
                },
                {
                  "type": "label",
                  "variable": "formData.packingMode",
                  "label": "Packing Mode",
                  "printable": true
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.shippingMarks",
                  "label": "Shipping Marks",
                  "printable": true
                },
                {
                  "type": "label",
                  "variable": "formData.shippingMode",
                  "label": "Shipping Mode",
                  "printable": true
                },
                {
                  "type": "label",
                  "label": "Shipping Date",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.shippingDate}})",
                  "printable": true
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Documents Required",
                  "printable": true
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Documents Required",
                  "disabled": "FALSE",
                  "items": "formData.requiredDocuments",
                  "printable": true,
                  "tableType": "static",
                  "showActions": false,
                  "headers": [
                    {
                      "value": "__item.name",
                      "text": "Name"
                    },
                    {
                      "value": "__item.original",
                      "text": "Original"
                    },
                    {
                      "value": "__item.copy",
                      "text": "Copy"
                    }
                  ]
                }
              ]
            },
            {
              "name": "8",
              "pageItems": [
                {
                  "type": "table",
                  "label": "PO Table",
                  "disabled": "FALSE",
                  "items": "formData.purchasedRMs",
                  "headers": [
                    {
                      "value": "__item.sparePart._id",
                      "text": "Material ID"
                    },
                    {
                      "value": "__item.sparePart.description",
                      "text": "Material Description"
                    },
                    {
                      "value": "__item.sparePart.unit",
                      "text": "Unit"
                    },
                    {
                      "value": "__item.unitQuantity",
                      "text": "Quantity",
                      "type": "formula",
                      "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.unitQuantity}},{{__item.rawMaterial}})}},{{__item.unitQuantity}})"
                    },
                    {
                      "value": "__item.unitPrice",
                      "text": "Unit Price",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,priceKgToSQM,{{__item.unitPrice}},{{__item.rawMaterial}})}},{{__item.unitPrice}}),{{formData.currencyCode}})"
                    },
                    {
                      "value": "__item.subtotal",
                      "text": "Subtotal",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,{{{{__item.unitQuantity}} * {{__item.unitPrice}}}},{{formData.currencyCode}})",
                      "showIf": "{{{{fetchedData.selectedSupplier.data.isInternational}} === false }}"
                    },
                    {
                      "value": "__item.subtotal1",
                      "text": "Total",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,{{{{__item.unitQuantity}} * {{__item.unitPrice}}}},{{formData.currencyCode}})",
                      "showIf": "{{{{fetchedData.selectedSupplier.data.isInternational}} === true }}"
                    },
                    {
                      "value": "__item.vatRate",
                      "text": "Vat Rate",
                      "type": "formula",
                      "formula": "{{fetchedData.companyDetails.data.0.data.vatPercentage}}%",
                      "showIf": "{{{{fetchedData.selectedSupplier.data.isInternational}} === false }}"
                    },
                    {
                      "value": "__item.vatValue",
                      "text": "Vat Value",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{fetchedData.companyDetails.data.0.data.vatPercentage}},0.01,{{__item.unitQuantity}},{{__item.unitPrice}}),{{formData.currencyCode}})",
                      "showIf": "{{{{fetchedData.selectedSupplier.data.isInternational}} === false }}"
                    },
                    {
                      "value": "__item.total",
                      "text": "Total",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,fn(SUM,fn(MULTIPLY,{{fetchedData.companyDetails.data.0.data.vatPercentage}},0.01),1),{{__item.unitQuantity}},{{__item.unitPrice}}),{{formData.currencyCode}})",
                      "showIf": "{{{{fetchedData.selectedSupplier.data.isInternational}} === false }}"
                    }
                  ],
                  "printable": true,
                  "tableType": "static",
                  "showActions": false,
                  "footer": {
                    "value": "fn(HELPER_FN,currency,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{fetchedData.quotation.data.items}},product._id))",
                    "unitPrice": "Grand Total",
                    "subtotal": "fn(HELPER_FN,currency,cy,fn(ARRAY_SUM,{{{{__item.unitQuantity}} * {{__item.unitPrice}}}},{{formData.purchasedRMs}}),{{formData.currencyCode}})",
                    "subtotal1": "fn(HELPER_FN,currency,fn(ARRAY_SUM,{{{{__item.unitQuantity}} * {{__item.unitPrice}}}},{{formData.purchasedRMs}}),{{formData.currencyCode}})",
                    "vatValue": "fn(HELPER_FN,currency,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{fetchedData.companyDetails.data.0.data.vatPercentage}},0.01,{{__arrayItem.unitQuantity}},{{__arrayItem.unitPrice}}),{{formData.purchasedRMs}},sparePart._id),{{formData.currencyCode}})",
                    "total": "fn(HELPER_FN,currency,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,fn(SUM,fn(MULTIPLY,{{fetchedData.companyDetails.data.0.data.vatPercentage}},0.01),1),{{__arrayItem.unitQuantity}},{{__arrayItem.unitPrice}}),{{formData.purchasedRMs}},sparePart._id),{{formData.currencyCode}})",
                  }
                }
              ]
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "formData",
                  "label": "Approval Table",
                  "disabled": "FALSE",
                  "items": "fetchedData.approvalData",
                  "printable": true,
                  "tableType": "static",
                  "showActions": false,
                  "headers": [
                    {
                      "value": "__item.preparedBy.displayName",
                      "text": "Prepared By"
                    },
                    {
                      "value": "__item.approvedBy.displayName",
                      "text": "Approved By"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllSuppliers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/suppliers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierList"
        },
        "name": "getAllSuppliers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Commercial | Purchaser))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMySuppliers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/suppliers/my",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierList"
        },
        "name": "getMySuppliers",
        "executeIf": "fn(MATCH_ROLE,Commercial | Purchaser)"
      },
      {
        "executionOrder": 1,
        "name": "getAllSpareParts"
      },
      {
        "executionOrder": 1,
        "name": "copyRmType"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCompanyDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=company-detail",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.companyDetails"
        },
        "name": "getCompanyDetails"
      },
      {
        "executionOrder": 2,
        "name": "getPoDetails"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getTradeTermDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=trade-terms",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.tradeTermsDetails"
        },
        "name": "getTradeTermDetails"
      }
    ],
    "functions": [
      {
        "name": "getAllSpareParts",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/sparepart",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.allSpareParts"
      },
      {
        "name": "copySupplierInternationalStatus",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject.isInternational",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.isInternational"
      },
      {
        "name": "copyRmType",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "createRMType",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "createRMType",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "rmType": "SP"
        },
        "useFormula": true
      },
      {
        "name": "getPoDetails",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/{{__params.poId}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.poDetails",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "[{\"name\":\"copyPoDetails\",\"executionOrder\":1},{\"name\":\"pushApprovalTableData\",\"executionOrder\":2},{\"name\":\"getSupplier\",\"executionOrder\":3}]"
      },
      {
        "name": "copyPoDetails",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "fetchedData.poDetails.data",
        "arg2Key": "destinationKey",
        "arg2Value": "formData"
      },
      {
        "name": "getApprovalDetails",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "preparedBy": "formData.createdBy",
          "approvedBy": "formData.approvedBy"
        }
      },
      {
        "name": "pushApprovalTableData",
        "type": "fnPushToArray",
        "arg1Key": "sourceFn",
        "arg1Value": "getApprovalDetails",
        "arg2Key": "destinationVariable",
        "arg2Value": "fetchedData.approvalData"
      },
      {
        "name": "getSupplier",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/suppliers/{{formData.supplier._id}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.selectedSupplier"
      },
      {
        "name": "updatePO",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/purchaseorder/{{__params.poId}}",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "requestMethod",
        "arg3Value": "PUT",
        "arg4Key": "refreshPage",
        "arg4Value": "TRUE"
      }
    ]
  },
  "forRole": "COMMERCIAL_PURCHASER,COMMERCIAL_MANAGER",
  "visible": false
}